"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  apiUrl: ""
};


// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-fleetlink/fleetlink.config.js